import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../../core/services/auth';

@Component({
  selector: 'app-account-pending-approval',
  standalone: true,
  imports: [CommonModule, CardModule, ButtonModule],
  templateUrl: './account-pending-approval.html',
  styleUrls: ['./account-pending-approval.scss']
})
export class AccountPendingApproval implements OnInit {

  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // Component initialization logic can be added here
  }

  goToLogin(): void {
    this.authService.logout();
  }

  goToAccountSetup(): void {
    // Redirect to account setup if user wants to modify their information
    this.router.navigate(['/user-account-setup']);
  }
} 